var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M8.38028 8.30376L13.4954 3.87066C14.1046 3.34608 14.9688 3.2373 15.689 3.59453L15.7014 3.60067L15.7188 3.60943C16.6987 4.10463 17.0962 5.2971 16.6094 6.28115L15.8416 7.81672C15.2913 8.91742 15.0161 9.46777 15.199 9.89417C15.2381 9.98526 15.2905 10.07 15.3545 10.1457C15.6541 10.5 16.2694 10.5 17.5 10.5H17.6305C19.3895 10.5 20.269 10.5 20.8399 11.0152C20.8907 11.061 20.939 11.1093 20.9848 11.1601C21.5 11.731 21.5 12.6105 21.5 14.3695V15.6849C21.5 16.5783 21.5 17.025 21.3213 17.4189C21.1425 17.8128 20.8064 18.1069 20.134 18.6952L18.6311 20.0103C18.0718 20.4997 17.7921 20.7444 17.452 20.8722C17.1119 21 16.7403 21 15.9971 21H12.1472C11.5774 21 11.2925 21 11.0222 20.9225C10.752 20.845 10.5104 20.694 10.0272 20.392L8.88 19.675C7.96095 19.1006 7.50143 18.8134 7.25072 18.361C7 17.9087 7 17.3668 7 16.283V18.5C7 19.3284 6.32843 20 5.5 20H4.5C3.39543 20 2.5 19.1046 2.5 18V10C2.5 8.89543 3.39543 8 4.5 8H5.5C6.32843 8 7 8.67157 7 9.5V11.3265C7 10.4277 7 9.97823 7.1807 9.58251C7.3614 9.18679 7.70102 8.89245 8.38028 8.30376Z",
    fill: "#0F973D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLike);
export default __webpack_public_path__ + "static/media/ic_like.dfb3479de579c530804e5d124b2a62bf.svg";
export { ForwardRef as ReactComponent };